import React, { useEffect, useMemo, useRef, useState, useCallback } from "react";
import axios from "axios";
import "@/App.css";
import {
  Upload,
  CheckCircle2,
  AlertTriangle,
  XCircle,
  Sparkles,
  Download,
  FileText,
  X,
  ArrowRight,
  RotateCcw,
  Loader2,
  Search,
  Watch,
  Pencil,
  Check,
  Languages,
  ChevronDown,
  FileSpreadsheet,
  Package,
  Wallet,
  Settings,
} from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// ---------------- Spanish dictionary ----------------
const T = {
  brand: "Relojes · Merchant Center",
  subtitle: "Conformidad y reformulación IA para Google Merchant",
  uploadCTA: "Subir archivo CSV (Shopify)",
  uploadHint: "Arrastra tu export de productos Shopify o haz clic para seleccionar",
  uploadAccepted: "Formato aceptado: .csv",
  analyzing: "Analizando catálogo...",
  sessionReady: "Catálogo analizado",
  totalProducts: "Total de productos",
  compliant: "Conformes",
  warnings: "Advertencias",
  nonCompliant: "No conformes",
  reformulateAll: "Reformular todo el catálogo",
  reformulateSelected: "Reformular",
  reformulateSelection: "seleccionados",
  reformulateOne: "Reformular con IA",
  exportCSV: "Exportar CSV corregido",
  selected: "Seleccionados",
  selectAll: "Seleccionar todos (filtrados)",
  clearSelection: "Limpiar selección",
  quickSelect: "Selección rápida",
  quickFail: "Solo No conformes",
  quickWarn: "Solo Advertencias",
  quickPass: "Solo Conformes",
  quickNotReformulated: "Sin reformular aún",
  quickNotTranslated: "Sin traducir aún",
  quickInvert: "Invertir selección",
  exportDropdown: "Exportar",
  exportES: "CSV Español (reformulado)",
  exportLang: "CSV en",
  exportAll: "ZIP con todos los idiomas",
  exportReport: "Informe Excel (.xlsx)",
  exportFeed: "Feed XML Google Merchant",
  feedModalTitle: "Generar feed XML Google Merchant",
  feedModalHint: "Pega la URL de tu tienda. Se generará el feed RSS 2.0 con el namespace g: para importar directamente en Google Merchant Center.",
  feedShopUrlLabel: "URL de la tienda",
  feedShopUrlPlaceholder: "https://tu-tienda.es",
  feedLanguageLabel: "Idioma del feed",
  feedCurrencyLabel: "Divisa",
  feedGenerate: "Descargar feed XML",
  feedPublic: "Generar URL pública permanente",
  feedPublicTitle: "URL pública permanente",
  feedPublicHint: "Esta URL permanece activa. Pégala directamente en Google Merchant Center (Fuentes de datos → Añadir archivo → Feed programado) para que lo recupere automáticamente cada día.",
  feedCopyUrl: "Copiar URL",
  feedCopied: "Copiado",
  feedExistingPublic: "URLs públicas existentes",
  feedDelete: "Eliminar",
  feedFetches: "descargas",
  translate: "Traducir con IA",
  translateEco: "Traducir (modo eco)",
  translateEcoTitle: "Modo eco: traducir sin reformular",
  translateTitle: "Traducir catálogo a otros idiomas",
  translateHint: "Selecciona los idiomas objetivo. Por defecto se traducen los productos reformulados; activa la opción si quieres traducir también los productos sin reformular (se usará el contenido original).",
  translateStart: "Iniciar traducción",
  translateIncludeRaw: "Incluir productos sin reformular (usar contenido original)",
  translatingLabel: "Traduciendo productos",
  languageTab: "Idioma",
  noTranslationYet: "Este producto aún no ha sido traducido a este idioma.",
  translateThis: "Traducir este producto",
  translationError: "Error en la traducción",
  newUpload: "Nuevo análisis",
  filterAll: "Todos",
  filterPass: "Conformes",
  filterWarn: "Advertencias",
  filterFail: "No conformes",
  filterReformulated: "Reformulados",
  filterTranslated: "Traducidos",
  notifTitleDone: "Proceso completado",
  notifBodyReform: "La reformulación con IA ha terminado.",
  notifBodyTrans: "La traducción ha terminado.",
  notifEnable: "Activar notificaciones",
  notifEnabled: "Notificaciones activadas",
  notifDenied: "Notificaciones bloqueadas (revísalo en tu navegador)",
  search: "Buscar por título, marca o SKU...",
  colImg: "",
  colProduct: "Producto",
  colBrand: "Marca",
  colPrice: "Precio",
  colVariants: "Variantes",
  colStatus: "Estado",
  colActions: "Acciones",
  variants: "variantes",
  processing: "Procesando con IA",
  processingLabel: "Reformulando catálogo con GPT-5.2",
  productOf: "de",
  close: "Cerrar",
  issuesTitle: "Incidencias detectadas",
  originalTitle: "Título original",
  reformulatedTitle: "Título reformulado",
  originalDesc: "Descripción original",
  reformulatedDesc: "Descripción reformulada",
  attributes: "Atributos sugeridos",
  brand_: "Marca",
  category: "Categoría Google",
  condition: "Estado",
  gender: "Género",
  ageGroup: "Grupo de edad",
  seoTitle: "SEO Title",
  seoDesc: "SEO Description",
  gtin: "GTIN / EAN",
  gtinFound: "encontrado",
  gtinNotFound: "No encontrado (dejar vacío + advertencia)",
  gtinConfidence: "Confianza",
  gtinReason: "Razonamiento",
  gtinExisting: "GTIN ya presente",
  gtinManual: "Manual",
  gtinEdit: "Corregir manualmente",
  gtinSave: "Guardar",
  gtinCancel: "Cancelar",
  gtinClear: "Borrar",
  gtinPlaceholder: "Introduce 8, 12, 13 o 14 dígitos",
  gtinInvalid: "Formato inválido. Debe tener 8, 12, 13 o 14 dígitos.",
  gtinCached: "Caché",
  noneYet: "Todavía no reformulado",
  reformulateNow: "Reformular ahora",
  beforeAfter: "Antes / Después",
  stats_before: "Antes",
  stats_after: "Después",
  viewDetails: "Ver detalles",
  errorUpload: "Error al subir el archivo",
  errorReformulate: "Error al reformular",
  noProducts: "No hay productos que coincidan con los filtros.",
  guidelines: "Requisitos Google Merchant",
  resumeTitle: "Sesiones anteriores",
  resumeHint: "Reanuda donde lo dejaste sin volver a subir el CSV.",
  resumeButton: "Reanudar",
  resumeDelete: "Eliminar",
  resumeNone: "Aún no hay sesiones guardadas.",
  resumeReformulated: "reformulados",
  resumeTranslated: "traducidos",
  resumeSearch: "Buscar por nombre de archivo...",
  resumeFilterAll: "Todas",
  resumeFilterReformulated: "Con reformulación",
  resumeFilterTranslated: "Con traducción",
  resumeFilterEmpty: "Vacías",
  resumeFilterLang: "Idioma",
  resumeNoMatch: "Ninguna sesión coincide con los filtros.",
  rules_title: "Título: 50-140 caracteres, sin promoción ni mayúsculas.",
  rules_desc: "Descripción: 600-2500 caracteres, HTML limpio.",
  rules_gtin: "GTIN / EAN buscado automáticamente con EAN-Search.",
  rules_brand: "Marca, categoría Google y estado definidos.",
  poweredBy: "Motor IA: OpenAI GPT-5.2 · Emergent",
  footer: "© 2026 Panel de Conformidad · Construido sobre Emergent",
  // Budget / cost tracking
  budgetThisSession: "Esta sesión",
  budgetThisMonth: "Este mes",
  budgetSettings: "Presupuesto",
  budgetTitle: "Presupuesto y consumo IA",
  budgetHint: "Limita tu gasto en GPT-5.2. Las nuevas reformulaciones o traducciones se bloquean automáticamente al alcanzar el límite. Las cifras incluyen tokens entrada+salida con precios oficiales OpenAI (1,75 $ / 14 $ por millón).",
  budgetEnabled: "Activar límites",
  budgetMonthlyLabel: "Límite mensual (€)",
  budgetSessionLabel: "Límite por sesión (€)",
  budgetSave: "Guardar",
  budgetSaved: "Presupuesto guardado",
  budgetCalls: "llamadas",
  budgetTokens: "tokens",
  budgetBlocked: "Presupuesto agotado",
  budgetReformBlocked: "No se puede reformular: presupuesto agotado.",
  budgetTransBlocked: "No se puede traducir: presupuesto agotado.",
  budgetAllTime: "Total acumulado",
  budgetByMode: "Desglose por proceso",
  modeReformulate: "Reformulación",
  modeTranslate: "Traducción",
  modeGtin: "Validación GTIN",
  // Compliance toolbar
  conservativeMode: "Modo conservador",
  conservativeModeHint: "Modo prudente: solo limpia el contenido original sin añadir adjetivos comerciales. Recomendado tras un rechazo de Google Merchant.",
  cleanSession: "Limpiar contenido",
  cleanSessionHint: "Elimina símbolos promocionales (-%, !!), cadenas Shopify ('Translation missing:', es.cart…) y artefactos del catálogo. Sin coste IA.",
  complianceReport: "Verificar cumplimiento",
  complianceModalTitle: "Informe de cumplimiento Google Merchant",
  complianceCategoryLabel: "Categoría",
  complianceCountLabel: "Ocurrencias",
  complianceProductsLabel: "Productos afectados",
  complianceNone: "Ningún producto con incumplimientos detectados.",
  complianceClose: "Cerrar",
};

const statusLabel = { pass: "Conforme", warning: "Advertencia", fail: "No conforme" };
const statusClass = { pass: "badge-pass", warning: "badge-warn", fail: "badge-fail" };

// ---------------- Utility ----------------
function Stat({ label, value, tone = "neutral", testid }) {
  const toneClass = {
    pass: "badge-pass",
    warning: "badge-warn",
    fail: "badge-fail",
    neutral: "badge-neutral",
  }[tone];
  return (
    <div className="stat-card" data-testid={testid}>
      <div className="label-overline">{label}</div>
      <div className="flex items-baseline justify-between mt-4">
        <div className="font-serif-display" style={{ fontSize: 44, fontWeight: 500, lineHeight: 1 }}>
          {value}
        </div>
        <span className={`badge ${toneClass}`} style={{ alignSelf: "center" }}>
          {tone === "pass" && "OK"}
          {tone === "warning" && "WARN"}
          {tone === "fail" && "ERR"}
          {tone === "neutral" && "TOT"}
        </span>
      </div>
    </div>
  );
}

function StatusBadge({ status }) {
  return (
    <span className={`badge ${statusClass[status] || "badge-neutral"}`} data-testid={`status-badge-${status}`}>
      {status === "pass" && <CheckCircle2 size={12} strokeWidth={2} />}
      {status === "warning" && <AlertTriangle size={12} strokeWidth={2} />}
      {status === "fail" && <XCircle size={12} strokeWidth={2} />}
      {statusLabel[status]}
    </span>
  );
}

// ---------------- Upload View ----------------
function UploadView({ onUploaded }) {
  const [dragOver, setDragOver] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");
  const [sessions, setSessions] = useState([]);
  const [resumeSearch, setResumeSearch] = useState("");
  const [resumeFilter, setResumeFilter] = useState("all"); // all | reformulated | translated | empty | lang:xx
  const inputRef = useRef(null);

  useEffect(() => {
    axios.get(`${API}/sessions`).then(r => setSessions(r.data || [])).catch(() => {});
  }, []);

  const refreshSessions = async () => {
    try { const r = await axios.get(`${API}/sessions`); setSessions(r.data || []); } catch {}
  };

  const handleResume = async (sessionId) => {
    try {
      const r = await axios.get(`${API}/session/${sessionId}`);
      onUploaded({
        session_id: r.data.session_id,
        filename: r.data.filename,
        total_products: r.data.total_products,
        created_at: r.data.created_at,
        stats: r.data.stats,
        products: r.data.products,
      });
    } catch (e) {
      setError("No se pudo reanudar la sesión.");
    }
  };

  const handleDeleteSession = async (sessionId, e) => {
    e?.stopPropagation();
    if (!window.confirm("¿Eliminar esta sesión y sus feeds públicos?")) return;
    try {
      await axios.delete(`${API}/session/${sessionId}`);
      await refreshSessions();
    } catch {}
  };

  const handleFiles = async (files) => {
    if (!files || files.length === 0) return;
    const file = files[0];
    if (!file.name.toLowerCase().endsWith(".csv")) {
      setError("Solo se admiten archivos .csv");
      return;
    }
    setError("");
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      const resp = await axios.post(`${API}/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onUploaded(resp.data);
    } catch (e) {
      console.error(e);
      setError(e?.response?.data?.detail || T.errorUpload);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto pt-12 pb-20 px-6">
      <div className="mb-10">
        <div className="label-overline" style={{ color: "var(--brand-accent)" }}>Google Merchant Center · España</div>
        <h1 className="font-serif-display mt-3" style={{ fontSize: 56, fontWeight: 500, lineHeight: 1.05 }}>
          Catálogo de relojes <br />
          <span style={{ color: "var(--brand-accent)" }}>conforme y reformulado</span>
        </h1>
        <p className="mt-5 max-w-2xl" style={{ color: "var(--text-secondary)", fontSize: 16, lineHeight: 1.65 }}>
          Sube tu export de Shopify y obtén un análisis detallado de cada producto
          según las políticas de Google Merchant. La IA reformula títulos, descripciones
          y atributos para garantizar la aprobación del feed.
        </p>
      </div>

      <div
        className={`dropzone ${dragOver ? "dragover" : ""}`}
        onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
        onDragLeave={() => setDragOver(false)}
        onDrop={(e) => { e.preventDefault(); setDragOver(false); handleFiles(e.dataTransfer.files); }}
        onClick={() => inputRef.current?.click()}
        data-testid="upload-dropzone"
      >
        <input
          ref={inputRef}
          type="file"
          accept=".csv"
          onChange={(e) => handleFiles(e.target.files)}
          data-testid="upload-file-input"
        />
        {uploading ? (
          <div className="flex flex-col items-center gap-4">
            <Loader2 className="animate-spin" size={40} strokeWidth={1.5} />
            <div className="label-overline">{T.analyzing}</div>
          </div>
        ) : (
          <div className="flex flex-col items-center gap-4">
            <div style={{ padding: 16, border: "1px solid var(--border-default)", borderRadius: 2 }}>
              <Upload size={28} strokeWidth={1.5} />
            </div>
            <div>
              <div className="font-serif-display" style={{ fontSize: 24 }}>{T.uploadCTA}</div>
              <div className="mt-2" style={{ color: "var(--text-tertiary)", fontSize: 13 }}>{T.uploadHint}</div>
              <div className="mt-1" style={{ color: "var(--text-tertiary)", fontSize: 11, letterSpacing: "0.1em", textTransform: "uppercase" }}>
                {T.uploadAccepted}
              </div>
            </div>
          </div>
        )}
      </div>

      {error && (
        <div className="mt-6 panel" style={{ padding: 16, borderColor: "var(--fail-border)", background: "var(--fail-bg)", color: "var(--fail-text)" }} data-testid="upload-error">
          {error}
        </div>
      )}

      <div className="mt-12 panel" style={{ padding: "28px 32px" }}>
        <div className="label-overline">{T.guidelines}</div>
        <ul className="mt-4 space-y-2.5" style={{ color: "var(--text-secondary)", fontSize: 13.5 }}>
          <li className="flex gap-3"><span style={{ color: "var(--brand-accent)" }}>◆</span> {T.rules_title}</li>
          <li className="flex gap-3"><span style={{ color: "var(--brand-accent)" }}>◆</span> {T.rules_desc}</li>
          <li className="flex gap-3"><span style={{ color: "var(--brand-accent)" }}>◆</span> {T.rules_gtin}</li>
          <li className="flex gap-3"><span style={{ color: "var(--brand-accent)" }}>◆</span> {T.rules_brand}</li>
        </ul>
      </div>

      {/* Previous sessions */}
      <div className="mt-6 panel" style={{ padding: "28px 32px" }} data-testid="resume-sessions-panel">
        <div className="flex items-center justify-between gap-4 flex-wrap">
          <div>
            <div className="label-overline">{T.resumeTitle}</div>
            <div className="font-serif-display mt-2" style={{ fontSize: 22, fontWeight: 500 }}>{T.resumeHint}</div>
          </div>
          <span className="badge badge-neutral">{sessions.length}</span>
        </div>

        {sessions.length === 0 ? (
          <div className="mt-5" style={{ color: "var(--text-tertiary)", fontSize: 13 }}>{T.resumeNone}</div>
        ) : (() => {
          // Build filtered list
          const allLangs = Array.from(new Set(sessions.flatMap(s => s.languages || []))).sort();
          let list = sessions;
          if (resumeSearch.trim()) {
            const q = resumeSearch.trim().toLowerCase();
            list = list.filter(s => (s.filename || "").toLowerCase().includes(q));
          }
          if (resumeFilter === "reformulated") list = list.filter(s => (s.reformulated_count || 0) > 0);
          else if (resumeFilter === "translated") list = list.filter(s => (s.translated_count || 0) > 0);
          else if (resumeFilter === "empty") list = list.filter(s => !s.reformulated_count && !s.translated_count);
          else if (resumeFilter.startsWith("lang:")) {
            const lang = resumeFilter.slice(5);
            list = list.filter(s => (s.languages || []).includes(lang));
          }

          return (
            <>
              {/* Search + filter chips */}
              <div className="mt-5 flex items-center gap-3 flex-wrap" data-testid="resume-controls">
                <div className="relative" style={{ flex: "1 1 300px", maxWidth: 380 }}>
                  <Search size={13} style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "var(--text-tertiary)" }} />
                  <input
                    type="text"
                    value={resumeSearch}
                    onChange={(e) => setResumeSearch(e.target.value)}
                    placeholder={T.resumeSearch}
                    data-testid="resume-search-input"
                    style={{
                      width: "100%", height: 34, padding: "0 12px 0 32px",
                      border: "1px solid var(--border-default)",
                      background: "var(--bg-surface)",
                      fontFamily: "inherit", fontSize: 13, outline: "none", borderRadius: 2,
                    }}
                  />
                </div>
                <FilterTab label={T.resumeFilterAll} active={resumeFilter==="all"} onClick={() => setResumeFilter("all")} testid="resume-filter-all" />
                <FilterTab label={T.resumeFilterReformulated} active={resumeFilter==="reformulated"} onClick={() => setResumeFilter("reformulated")} testid="resume-filter-reformulated" />
                <FilterTab label={T.resumeFilterTranslated} active={resumeFilter==="translated"} onClick={() => setResumeFilter("translated")} testid="resume-filter-translated" />
                <FilterTab label={T.resumeFilterEmpty} active={resumeFilter==="empty"} onClick={() => setResumeFilter("empty")} testid="resume-filter-empty" />
                {allLangs.length > 0 && (
                  <select
                    value={resumeFilter.startsWith("lang:") ? resumeFilter : ""}
                    onChange={(e) => e.target.value ? setResumeFilter(e.target.value) : setResumeFilter("all")}
                    data-testid="resume-filter-lang"
                    style={{
                      height: 34, padding: "0 10px",
                      border: "1px solid var(--border-default)",
                      background: "var(--bg-surface)",
                      fontFamily: "inherit", fontSize: 12, outline: "none", borderRadius: 2,
                    }}
                  >
                    <option value="">{T.resumeFilterLang}…</option>
                    {allLangs.map(l => (
                      <option key={l} value={`lang:${l}`}>{l.toUpperCase()}</option>
                    ))}
                  </select>
                )}
              </div>

              <div className="mt-5" style={{ borderTop: "1px solid var(--border-default)" }}>
                {list.length === 0 ? (
                  <div className="py-6 text-center" style={{ color: "var(--text-tertiary)", fontSize: 13 }}>{T.resumeNoMatch}</div>
                ) : list.slice(0, 10).map(s => {
                  const date = (s.created_at || "").replace("T", " ").slice(0, 16);
                  const reformPct = s.total_products > 0 ? Math.round((s.reformulated_count / s.total_products) * 100) : 0;
                  const transPct = s.total_products > 0 ? Math.round((s.translated_count / s.total_products) * 100) : 0;
                  return (
                    <div
                      key={s.session_id}
                      className="flex items-center gap-4 py-3"
                      style={{ borderBottom: "1px solid var(--border-default)", cursor: "pointer" }}
                      onClick={() => handleResume(s.session_id)}
                      onMouseEnter={(e) => e.currentTarget.style.background = "var(--bg-surface-hover)"}
                      onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
                      data-testid={`resume-session-${s.session_id}`}
                    >
                      <div style={{ flex: 2, minWidth: 0 }}>
                        <div className="truncate" style={{ fontSize: 13.5, fontWeight: 500 }}>{s.filename || "(sin nombre)"}</div>
                        <div className="label-overline mt-1" style={{ color: "var(--text-tertiary)" }}>{date}</div>
                      </div>
                      <div style={{ flex: 1, display: "flex", gap: 12, justifyContent: "flex-end", flexWrap: "wrap" }}>
                        <span className="badge badge-neutral">{s.total_products} prod</span>
                        {s.reformulated_count > 0 && (
                          <span className="badge badge-proc"><Sparkles size={10} /> {reformPct}% {T.resumeReformulated}</span>
                        )}
                        {s.translated_count > 0 && (
                          <span className="badge badge-pass"><Languages size={10} /> {transPct}% {(s.languages || []).join(",").toUpperCase()}</span>
                        )}
                      </div>
                      <button
                        className="btn btn-secondary"
                        onClick={(e) => { e.stopPropagation(); handleResume(s.session_id); }}
                        data-testid={`resume-btn-${s.session_id}`}
                      >
                        <ArrowRight size={12} /> {T.resumeButton}
                      </button>
                      <button
                        className="btn btn-ghost"
                        onClick={(e) => handleDeleteSession(s.session_id, e)}
                        data-testid={`delete-session-${s.session_id}`}
                        style={{ color: "var(--fail-text)" }}
                        title={T.resumeDelete}
                      >
                        <X size={12} />
                      </button>
                    </div>
                  );
                })}
                {list.length > 10 && (
                  <div className="label-overline mt-3" style={{ color: "var(--text-tertiary)" }}>
                    + {list.length - 10} sesiones más antiguas (no mostradas)
                  </div>
                )}
              </div>
            </>
          );
        })()}
      </div>
    </div>
  );
}

// ---------------- Product Detail Modal ----------------
function ProductDetail({ sessionId, handle, onClose, onUpdated }) {
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [reformulating, setReformulating] = useState(false);
  const [activeLang, setActiveLang] = useState("es");
  const [translating, setTranslating] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await axios.get(`${API}/session/${sessionId}/product/${handle}`);
      setProduct(r.data);
    } finally {
      setLoading(false);
    }
  }, [sessionId, handle]);

  useEffect(() => { load(); }, [load]);

  const pollProgress = useCallback(async (onDone) => {
    let tries = 0;
    const tick = async () => {
      const pr = await axios.get(`${API}/session/${sessionId}/progress`);
      if (pr.data.progress.status === "done" || tries++ > 80) {
        await load();
        onUpdated?.();
        onDone?.();
        return;
      }
      setTimeout(tick, 1500);
    };
    setTimeout(tick, 1200);
  }, [sessionId, load, onUpdated]);

  const startReformulate = async () => {
    setReformulating(true);
    try {
      await axios.post(`${API}/session/${sessionId}/reformulate`, { handles: [handle] });
      pollProgress(() => setReformulating(false));
    } catch (e) {
      console.error(e);
      setReformulating(false);
    }
  };

  const translateThisProduct = async (lang) => {
    setTranslating(true);
    try {
      await axios.post(`${API}/session/${sessionId}/translate`, { handles: [handle], languages: [lang] });
      pollProgress(() => setTranslating(false));
    } catch (e) {
      console.error(e);
      setTranslating(false);
    }
  };

  const stopProp = (e) => e.stopPropagation();

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-panel" onClick={stopProp} data-testid="product-detail-modal">
        <div className="flex items-center justify-between px-8 py-5" style={{ borderBottom: "1px solid var(--border-default)", background: "var(--bg-surface)" }}>
          <div className="flex items-center gap-4 min-w-0">
            {product?.image && (
              <img src={product.image} alt="" style={{ width: 56, height: 56, objectFit: "cover", border: "1px solid var(--border-default)" }} />
            )}
            <div className="min-w-0">
              <div className="label-overline">{product?.vendor || "—"}</div>
              <div className="font-serif-display truncate" style={{ fontSize: 22, fontWeight: 500, maxWidth: 700 }}>
                {product?.title || "—"}
              </div>
            </div>
          </div>
          <button className="btn btn-ghost" onClick={onClose} data-testid="close-detail-button">
            <X size={16} /> {T.close}
          </button>
        </div>

        {loading || !product ? (
          <div className="flex items-center justify-center py-40"><Loader2 className="animate-spin" size={28} /></div>
        ) : (
          <div className="px-8 py-8 space-y-8">
            {/* Issues */}
            <section>
              <div className="flex items-center justify-between">
                <div className="label-overline">{T.issuesTitle}</div>
                <StatusBadge status={product.status_after || product.status} />
              </div>
              <div className="panel mt-3" style={{ padding: "8px 18px" }}>
                {(product.reformulated && !product.reformulated.error
                  ? (product.reformulated.new_issues || [])
                  : product.issues
                ).length === 0 ? (
                  <div className="py-5" style={{ color: "var(--pass-text)" }}>
                    <CheckCircle2 size={16} style={{ display: "inline", marginRight: 8 }} />
                    Sin incidencias detectadas.
                  </div>
                ) : (
                  (product.reformulated && !product.reformulated.error
                    ? product.reformulated.new_issues
                    : product.issues
                  ).map((iss, i) => (
                    <div key={i} className="issue-item" data-testid={`issue-${iss.field}`}>
                      <span className={`badge ${iss.severity === "fail" ? "badge-fail" : "badge-warn"}`}>
                        {iss.field}
                      </span>
                      <span style={{ color: "var(--text-secondary)" }}>{iss.message}</span>
                    </div>
                  ))
                )}
              </div>
            </section>

            {/* Reformulate CTA / action */}
            <section>
              <div className="flex items-center justify-between flex-wrap gap-3">
                <div className="label-overline">{T.beforeAfter}</div>
                <div className="flex gap-2 flex-wrap">
                  {!product.reformulated || product.reformulated.error ? (
                    <button
                      className="btn btn-primary"
                      onClick={startReformulate}
                      disabled={reformulating || translating}
                      data-testid="reformulate-single-button"
                    >
                      {reformulating ? <><span className="spinner" /> {T.processing}</> : <><Sparkles size={14} /> {T.reformulateNow}</>}
                    </button>
                  ) : (
                    <button
                      className="btn btn-secondary"
                      onClick={startReformulate}
                      disabled={reformulating || translating}
                      data-testid="reformulate-again-button"
                    >
                      {reformulating ? <><span className="spinner" /> {T.processing}</> : <><RotateCcw size={14} /> Volver a reformular</>}
                    </button>
                  )}
                </div>
              </div>

              {/* Language tabs */}
              {product.reformulated && !product.reformulated.error && (
                <div className="mt-4 flex items-center gap-1 flex-wrap" style={{ borderBottom: "1px solid var(--border-default)" }} data-testid="lang-tabs">
                  {["es", "fr", "en", "pt", "de", "it"].map(lang => {
                    const hasTrans = lang === "es" || (product.translations && product.translations[lang] && !product.translations[lang].error);
                    return (
                      <button
                        key={lang}
                        className={`pill-tab ${activeLang === lang ? "active" : ""}`}
                        onClick={() => setActiveLang(lang)}
                        data-testid={`lang-tab-${lang}`}
                        style={{ display: "inline-flex", alignItems: "center", gap: 6 }}
                      >
                        {lang === "es" ? "🇪🇸" : LANG_META[lang]?.flag} {lang === "es" ? "Español" : LANG_META[lang]?.name}
                        {!hasTrans && <span style={{ color: "var(--text-tertiary)", fontSize: 10 }}>·</span>}
                      </button>
                    );
                  })}
                </div>
              )}

              {(() => {
                const showLang = activeLang;
                const isEs = showLang === "es";
                const trans = !isEs ? (product.translations || {})[showLang] : null;
                const displayContent = isEs ? product.reformulated : (trans && !trans.error ? trans : null);
                const noTrans = !isEs && !displayContent;
                const reformulatedLabel = isEs ? T.reformulatedTitle : `${T.reformulatedTitle} (${LANG_META[showLang]?.name})`;

                return (
                  <>
                    {noTrans ? (
                      <div className="panel mt-4 px-6 py-10 text-center">
                        <div style={{ fontSize: 40 }}>{LANG_META[showLang]?.flag}</div>
                        <div className="mt-3" style={{ color: "var(--text-secondary)" }}>{T.noTranslationYet}</div>
                        <button
                          className="btn btn-primary mt-4"
                          onClick={() => translateThisProduct(showLang)}
                          disabled={translating || !product.reformulated || product.reformulated.error}
                          data-testid={`translate-this-${showLang}-button`}
                        >
                          {translating ? <><span className="spinner" /> {T.translatingLabel}</> : <><Languages size={14} /> {T.translateThis} ({LANG_META[showLang]?.name})</>}
                        </button>
                      </div>
                    ) : (
                      <>
                        {/* Title diff */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-0 mt-3" style={{ border: "1px solid var(--border-default)" }}>
                          <div className="diff-pane" style={{ borderRight: "1px solid var(--border-default)" }}>
                            <div className="label-overline">{T.originalTitle}</div>
                            <div className="mt-3" style={{ fontSize: 16, color: "var(--text-primary)", lineHeight: 1.4 }}>
                              {product.original.title || "—"}
                            </div>
                            <div className="mt-4 label-overline" style={{ color: "var(--text-tertiary)" }}>
                              {product.original.title?.length || 0} car.
                            </div>
                          </div>
                          <div className="diff-pane" style={{ background: "#FDFDFC" }}>
                            <div className="label-overline" style={{ color: "var(--brand-accent)" }}>{reformulatedLabel}</div>
                            {displayContent ? (
                              <>
                                <div className="mt-3" style={{ fontSize: 16, color: "var(--text-primary)", lineHeight: 1.4 }} data-testid="reformulated-title-text">
                                  {displayContent.title}
                                </div>
                                <div className="mt-4 label-overline" style={{ color: "var(--text-tertiary)" }}>
                                  {(displayContent.title || "").length} car.
                                </div>
                              </>
                            ) : (
                              <div className="mt-3" style={{ color: "var(--text-tertiary)", fontStyle: "italic" }}>{T.noneYet}</div>
                            )}
                          </div>
                        </div>

                        {/* Description diff */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-0 mt-3" style={{ border: "1px solid var(--border-default)" }}>
                          <div className="diff-pane" style={{ borderRight: "1px solid var(--border-default)" }}>
                            <div className="label-overline">{T.originalDesc}</div>
                            <div className="html-preview mt-3" dangerouslySetInnerHTML={{ __html: product.original.body_html || "—" }} />
                          </div>
                          <div className="diff-pane" style={{ background: "#FDFDFC" }}>
                            <div className="label-overline" style={{ color: "var(--brand-accent)" }}>{isEs ? T.reformulatedDesc : `${T.reformulatedDesc} (${LANG_META[showLang]?.name})`}</div>
                            {displayContent ? (
                              <div
                                className="html-preview mt-3"
                                dangerouslySetInnerHTML={{ __html: displayContent.body_html }}
                                data-testid="reformulated-body-preview"
                              />
                            ) : (
                              <div className="mt-3" style={{ color: "var(--text-tertiary)", fontStyle: "italic" }}>{T.noneYet}</div>
                            )}
                          </div>
                        </div>

                        {/* SEO for non-Spanish */}
                        {!isEs && displayContent && (
                          <div className="panel mt-4 px-6 py-5">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-3">
                              <div>
                                <div className="label-overline">SEO Title ({LANG_META[showLang]?.name})</div>
                                <div className="mt-1 font-mono" style={{ fontSize: 13 }}>{displayContent.seo_title}</div>
                              </div>
                              <div>
                                <div className="label-overline">SEO Description ({LANG_META[showLang]?.name})</div>
                                <div className="mt-1 font-mono" style={{ fontSize: 12.5, lineHeight: 1.5 }}>{displayContent.seo_description}</div>
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </>
                );
              })()}
            </section>

            {/* Legacy diff block removed below - skip the old title/description section */}

            {/* Attributes & SEO */}
            {product.reformulated && !product.reformulated.error && (
              <section>
                <div className="label-overline">{T.attributes}</div>
                <div className="panel mt-3" style={{ padding: "20px 22px" }}>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-4">
                    <AttrRow label={T.brand_} value={product.reformulated.brand} testid="attr-brand" />
                    <AttrRow label={T.category} value={product.reformulated.google_product_category} testid="attr-category" />
                    <AttrRow label={T.condition} value={product.reformulated.condition} testid="attr-condition" />
                    <AttrRow label={T.gender} value={product.reformulated.gender} testid="attr-gender" />
                    <AttrRow label={T.ageGroup} value={product.reformulated.age_group} testid="attr-age" />
                  </div>
                  <div style={{ height: 1, background: "var(--border-default)", margin: "18px 0" }} />
                  {/* GTIN */}
                  <GtinEditor
                    sessionId={sessionId}
                    handle={handle}
                    reformulated={product.reformulated}
                    onUpdated={() => { load(); onUpdated?.(); }}
                  />
                  <div style={{ height: 1, background: "var(--border-default)", margin: "18px 0" }} />
                  <AttrRow label={T.seoTitle} value={product.reformulated.seo_title} mono />
                  <div className="mt-3" />
                  <AttrRow label={T.seoDesc} value={product.reformulated.seo_description} mono />
                </div>
              </section>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

function AttrRow({ label, value, mono, testid }) {
  return (
    <div data-testid={testid}>
      <div className="label-overline">{label}</div>
      <div className={`mt-1 ${mono ? "font-mono" : ""}`} style={{ fontSize: 13, color: "var(--text-primary)" }}>
        {value || "—"}
      </div>
    </div>
  );
}

function GtinEditor({ sessionId, handle, reformulated, onUpdated }) {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(reformulated?.gtin || "");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => { setValue(reformulated?.gtin || ""); }, [reformulated?.gtin]);

  const confidence = reformulated?.gtin_confidence;
  const gtin = reformulated?.gtin;

  const badgeClass =
    confidence === "high" ? "badge-pass" :
    confidence === "manual" ? "badge-pass" :
    confidence === "existing" ? "badge-neutral" :
    "badge-warn";

  const badgeLabel =
    confidence === "manual" ? T.gtinManual :
    confidence === "existing" ? T.gtinExisting :
    `${T.gtinConfidence}: ${confidence || "none"}`;

  const save = async (raw) => {
    const trimmed = (raw ?? value).trim();
    if (trimmed && !/^\d{8}$|^\d{12,14}$/.test(trimmed)) {
      setError(T.gtinInvalid);
      return;
    }
    setError("");
    setSaving(true);
    try {
      await axios.patch(`${API}/session/${sessionId}/product/${handle}/gtin`, { gtin: trimmed });
      setEditing(false);
      onUpdated?.();
    } catch (e) {
      setError(e?.response?.data?.detail || "Error");
    } finally {
      setSaving(false);
    }
  };

  const clear = async () => {
    setValue("");
    await save("");
  };

  return (
    <div className="flex items-start justify-between gap-6 flex-wrap">
      <div style={{ flex: 1, minWidth: 240 }}>
        <div className="label-overline">{T.gtin}</div>

        {!editing ? (
          <>
            {gtin ? (
              <div className="mt-1 flex items-center gap-3 flex-wrap" data-testid="attr-gtin">
                <span className="font-mono" style={{ fontSize: 14, color: "var(--text-primary)", fontWeight: 500 }}>{gtin}</span>
                <span className={`badge ${badgeClass}`}>{badgeLabel}</span>
                {reformulated?.gtin_cached && (
                  <span className="badge badge-neutral" title="Resultado recuperado desde el caché">{T.gtinCached}</span>
                )}
                <button className="btn btn-ghost" onClick={() => setEditing(true)} data-testid="edit-gtin-button">
                  <Pencil size={12} /> {T.gtinEdit}
                </button>
                <button className="btn btn-ghost" onClick={clear} disabled={saving} data-testid="clear-gtin-button" style={{ color: "var(--fail-text)" }}>
                  {T.gtinClear}
                </button>
              </div>
            ) : (
              <div className="mt-1 flex items-center gap-3 flex-wrap" data-testid="attr-gtin-missing">
                <span style={{ fontSize: 13, color: "var(--warn-text)" }}>{T.gtinNotFound}</span>
                <button className="btn btn-secondary" onClick={() => setEditing(true)} data-testid="add-gtin-button">
                  <Pencil size={12} /> {T.gtinEdit}
                </button>
              </div>
            )}
            {reformulated?.gtin_reason && (
              <div className="mt-2" style={{ fontSize: 12, color: "var(--text-tertiary)", fontStyle: "italic" }}>
                {T.gtinReason}: {reformulated.gtin_reason}
              </div>
            )}
          </>
        ) : (
          <div className="mt-2">
            <div className="flex items-center gap-2 flex-wrap">
              <input
                type="text"
                value={value}
                onChange={(e) => setValue(e.target.value.replace(/\D/g, ""))}
                placeholder={T.gtinPlaceholder}
                autoFocus
                data-testid="gtin-input"
                onKeyDown={(e) => {
                  if (e.key === "Enter") save();
                  if (e.key === "Escape") { setEditing(false); setError(""); setValue(reformulated?.gtin || ""); }
                }}
                style={{
                  height: 36,
                  padding: "0 12px",
                  fontFamily: "'IBM Plex Mono', monospace",
                  fontSize: 14,
                  border: "1px solid var(--border-strong)",
                  background: "var(--bg-surface)",
                  outline: "none",
                  width: 220,
                  borderRadius: 2,
                }}
              />
              <button className="btn btn-primary" onClick={() => save()} disabled={saving} data-testid="save-gtin-button">
                {saving ? <span className="spinner" /> : <Check size={14} />} {T.gtinSave}
              </button>
              <button className="btn btn-secondary" onClick={() => { setEditing(false); setError(""); setValue(reformulated?.gtin || ""); }} data-testid="cancel-gtin-button">
                {T.gtinCancel}
              </button>
            </div>
            {error && (
              <div className="mt-2" style={{ fontSize: 12, color: "var(--fail-text)" }} data-testid="gtin-error">{error}</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

// ---------------- Dashboard ----------------
function Dashboard({ session, onReset }) {
  const [products, setProducts] = useState(session.products);
  const [statsBefore] = useState(session.stats);
  const [statsAfter, setStatsAfter] = useState(null);
  const [filter, setFilter] = useState("all");
  const [search, setSearch] = useState("");
  const [selectedHandle, setSelectedHandle] = useState(null);
  const [progress, setProgress] = useState({ status: "idle", total: 0, processed: 0 });
  const [exporting, setExporting] = useState(false);
  const [translateModalOpen, setTranslateModalOpen] = useState(false);
  const [translateEcoMode, setTranslateEcoMode] = useState(false);
  const [feedModalOpen, setFeedModalOpen] = useState(false);
  const [selectedHandles, setSelectedHandles] = useState(new Set());
  const [notifPermission, setNotifPermission] = useState(typeof Notification !== "undefined" ? Notification.permission : "unsupported");
  const lastModeRef = useRef(null);
  const [budget, setBudget] = useState(null); // { settings, month, all_time, session }
  const [budgetModalOpen, setBudgetModalOpen] = useState(false);

  const refreshBudget = useCallback(async () => {
    try {
      const [g, s] = await Promise.all([
        axios.get(`${API}/budget`),
        axios.get(`${API}/session/${session.session_id}/usage`),
      ]);
      setBudget({
        settings: g.data.settings,
        month: g.data.month,
        all_time: g.data.all_time,
        session: s.data.session,
        by_mode: s.data.by_mode,
      });
    } catch (e) { /* ignore */ }
  }, [session.session_id]);

  useEffect(() => { refreshBudget(); }, [refreshBudget]);

  const requestNotifPermission = async () => {
    if (typeof Notification === "undefined") return;
    try {
      const r = await Notification.requestPermission();
      setNotifPermission(r);
    } catch {}
  };

  const sendBrowserNotif = useCallback((title, body) => {
    if (typeof Notification === "undefined") return;
    if (Notification.permission !== "granted") return;
    try {
      const n = new Notification(title, { body, icon: "/favicon.ico", tag: "merchant-job-done" });
      n.onclick = () => { window.focus(); n.close(); };
      // Auto-close after 8s
      setTimeout(() => { try { n.close(); } catch {} }, 8000);
    } catch {}
  }, []);

  const refreshSession = useCallback(async () => {
    const r = await axios.get(`${API}/session/${session.session_id}`);
    setProducts(r.data.products);
    if (r.data.stats_after) setStatsAfter(r.data.stats_after);
  }, [session.session_id]);

  // Poll progress when running. Only refresh full session at the end (not each tick).
  useEffect(() => {
    let timer;
    let cancelled = false;
    const tick = async () => {
      if (cancelled) return;
      try {
        const r = await axios.get(`${API}/session/${session.session_id}/progress`);
        if (cancelled) return;
        // Track current operation mode (reformulate/translate) for notification copy
        const mode = r.data.progress?.mode;
        if (mode) lastModeRef.current = mode;
        setProgress(r.data.progress);
        if (r.data.stats_after) setStatsAfter(r.data.stats_after);
        if (r.data.progress.status === "running") {
          timer = setTimeout(tick, 3000);
        } else if (r.data.progress.status === "done") {
          await refreshSession();
          await refreshBudget();
          // Browser notification when the job finishes
          const isTranslate = lastModeRef.current === "translate";
          sendBrowserNotif(
            T.notifTitleDone,
            isTranslate ? T.notifBodyTrans : T.notifBodyReform,
          );
          lastModeRef.current = null;
        }
      } catch (e) { /* ignore network blips */ }
    };
    if (progress.status === "running") tick();
    return () => { cancelled = true; clearTimeout(timer); };
  }, [progress.status, session.session_id, refreshSession, refreshBudget, sendBrowserNotif]);

  const counts = useMemo(() => {
    const c = { all: products.length, pass: 0, warning: 0, fail: 0, reformulated: 0 };
    for (const p of products) {
      const eff = p.status_after || p.status;
      if (c[eff] !== undefined) c[eff] += 1;
      if (p.reformulated && !p.reformulated.error) c.reformulated += 1;
    }
    return c;
  }, [products]);

  const availableLanguages = useMemo(() => {
    const set = new Set();
    for (const p of products) {
      const t = p.translations || {};
      for (const [lang, v] of Object.entries(t)) {
        if (v && !v.error) set.add(lang);
      }
    }
    return Array.from(set).sort();
  }, [products]);

  const filtered = useMemo(() => {
    let list = products;
    if (filter === "pass") list = list.filter(p => (p.status_after || p.status) === "pass");
    else if (filter === "warning") list = list.filter(p => (p.status_after || p.status) === "warning");
    else if (filter === "fail") list = list.filter(p => (p.status_after || p.status) === "fail");
    else if (filter === "reformulated") list = list.filter(p => p.reformulated && !p.reformulated.error);
    if (search.trim()) {
      const s = search.trim().toLowerCase();
      list = list.filter(p =>
        (p.title || "").toLowerCase().includes(s) ||
        (p.vendor || "").toLowerCase().includes(s) ||
        (p.handle || "").toLowerCase().includes(s)
      );
    }
    return list;
  }, [products, filter, search]);

  const applyQuickSelect = (kind) => {
    let handles;
    if (kind === "fail") handles = products.filter(p => (p.status_after || p.status) === "fail").map(p => p.handle);
    else if (kind === "warn") handles = products.filter(p => (p.status_after || p.status) === "warning").map(p => p.handle);
    else if (kind === "pass") handles = products.filter(p => (p.status_after || p.status) === "pass").map(p => p.handle);
    else if (kind === "not_reformulated") handles = products.filter(p => !p.reformulated || p.reformulated.error).map(p => p.handle);
    else if (kind === "not_translated") handles = products.filter(p => {
      const t = p.translations || {};
      // Consider "translated" if has at least one successful translation to any language
      return !Object.values(t).some(v => v && !v.error);
    }).map(p => p.handle);
    else if (kind === "invert") {
      const all = new Set(products.map(p => p.handle));
      handles = Array.from(all).filter(h => !selectedHandles.has(h));
    }
    setSelectedHandles(new Set(handles));
  };

  const [conservativeMode, setConservativeMode] = useState(false);
  const [cleaning, setCleaning] = useState(false);
  const [complianceReport, setComplianceReport] = useState(null);

  const triggerReformulateAll = async () => {
    try {
      await axios.post(`${API}/session/${session.session_id}/reformulate`, { handles: null, conservative: conservativeMode });
      setProgress({ status: "running", total: 0, processed: 0 });
    } catch (e) {
      alert(e?.response?.data?.detail || T.errorReformulate);
    }
  };

  const triggerReformulateSelected = async () => {
    // If selection exists, use it; else fall back to current filter
    const handles = selectedHandles.size > 0
      ? Array.from(selectedHandles)
      : filtered.map(p => p.handle);
    if (handles.length === 0) return;
    try {
      await axios.post(`${API}/session/${session.session_id}/reformulate`, { handles, conservative: conservativeMode });
      setProgress({ status: "running", total: handles.length, processed: 0 });
    } catch (e) {
      alert(e?.response?.data?.detail || T.errorReformulate);
    }
  };

  const handleCleanSession = async () => {
    if (!window.confirm("¿Limpiar todos los productos reformulados/traducidos? Eliminará símbolos promocionales y artefactos Shopify, sin consumir tokens IA.")) return;
    setCleaning(true);
    try {
      const r = await axios.post(`${API}/session/${session.session_id}/clean`);
      await refreshSession();
      const cats = Object.entries(r.data.violations_summary || {}).map(([k, v]) => `${k}: ${v}`).join(" · ");
      alert(`Limpieza completada.\n${r.data.cleaned_products} productos modificados.\n${r.data.total_with_violations} productos con incumplimientos restantes.${cats ? "\nCategorías: " + cats : ""}`);
    } catch (e) {
      alert(e?.response?.data?.detail || "Error al limpiar.");
    } finally {
      setCleaning(false);
    }
  };

  const handleComplianceCheck = async () => {
    try {
      const r = await axios.get(`${API}/session/${session.session_id}/compliance`);
      setComplianceReport(r.data);
    } catch (e) {
      alert(e?.response?.data?.detail || "Error al verificar cumplimiento.");
    }
  };

  const handleExport = async (lang = null) => {
    setExporting(true);
    try {
      const handlesParam = selectedHandles.size > 0
        ? `handles=${encodeURIComponent(Array.from(selectedHandles).join(","))}`
        : null;
      const base = lang === "_all"
        ? `${API}/session/${session.session_id}/export-all`
        : lang
          ? `${API}/session/${session.session_id}/export?lang=${lang}`
          : `${API}/session/${session.session_id}/export`;
      const url = handlesParam ? `${base}${base.includes("?") ? "&" : "?"}${handlesParam}` : base;
      const r = await axios.get(url, { responseType: "blob" });
      const mime = lang === "_all" ? "application/zip" : "text/csv";
      const blobUrl = URL.createObjectURL(new Blob([r.data], { type: mime }));
      const a = document.createElement("a");
      a.href = blobUrl;
      const baseName = (session.filename || "products").replace(/\.csv$/i, "");
      const sel = selectedHandles.size > 0 ? `_sel${selectedHandles.size}` : "";
      a.download = lang === "_all"
        ? `${baseName}_google_merchant_all${sel}.zip`
        : lang
          ? `${baseName}_google_merchant_${lang}${sel}.csv`
          : `${baseName}_google_merchant_es${sel}.csv`;
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(blobUrl);
    } finally {
      setExporting(false);
    }
  };

  const handleExportReport = async () => {
    setExporting(true);
    try {
      const r = await axios.get(`${API}/session/${session.session_id}/report`, { responseType: "blob" });
      const url = URL.createObjectURL(new Blob([r.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }));
      const a = document.createElement("a");
      a.href = url;
      const base = (session.filename || "products").replace(/\.csv$/i, "");
      a.download = `${base}_informe_conformidad.xlsx`;
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
    } finally {
      setExporting(false);
    }
  };

  const triggerTranslation = async (languages, handles = null, includeNonReformulated = false) => {
    try {
      const payload = { languages, include_non_reformulated: includeNonReformulated };
      // If explicit handles passed, use them; else use selection; else null (all reformulated, or all if include_non_reformulated)
      if (handles) payload.handles = handles;
      else if (selectedHandles.size > 0) payload.handles = Array.from(selectedHandles);
      await axios.post(`${API}/session/${session.session_id}/translate`, payload);
      setProgress({ status: "running", total: 0, processed: 0, mode: "translate" });
    } catch (e) {
      alert(e?.response?.data?.detail || "Error en la traducción");
    }
  };

  const handleFeedDownload = ({ shopUrl, lang, currency }) => {
    const url = `${API}/session/${session.session_id}/feed.xml?shop_url=${encodeURIComponent(shopUrl)}&lang=${lang}&currency=${currency}`;
    window.location.href = url;
    setFeedModalOpen(false);
  };

  const pct = progress.total > 0 ? Math.min(100, Math.round((progress.processed / progress.total) * 100)) : 0;

  return (
    <div className="min-h-screen">
      {/* Header */}
      <header style={{ borderBottom: "1px solid var(--border-default)", background: "var(--bg-surface)" }}>
        <div className="max-w-7xl mx-auto px-6 py-5 flex items-center justify-between gap-6">
          <div className="flex items-center gap-4">
            <div style={{ border: "1px solid var(--border-strong)", padding: 8, borderRadius: 2 }}>
              <Watch size={18} strokeWidth={1.5} />
            </div>
            <div>
              <div className="font-serif-display" style={{ fontSize: 20, fontWeight: 500, lineHeight: 1 }}>{T.brand}</div>
              <div className="label-overline mt-1">{T.subtitle}</div>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <div className="label-overline hidden md:block mr-2" style={{ color: "var(--text-tertiary)" }}>
              <FileText size={12} style={{ display: "inline", marginRight: 6 }} />
              <span className="font-mono">{session.filename}</span>
            </div>
            {(notifPermission === "default" || notifPermission === "denied") && typeof Notification !== "undefined" && (
              <button
                className="btn btn-ghost"
                onClick={requestNotifPermission}
                data-testid="enable-notif-button"
                title={notifPermission === "denied" ? T.notifDenied : T.notifEnable}
                style={{ color: notifPermission === "denied" ? "var(--text-tertiary)" : "var(--brand-accent)" }}
              >
                🔔 {notifPermission === "denied" ? T.notifDenied : T.notifEnable}
              </button>
            )}
            {notifPermission === "granted" && (
              <span className="label-overline hidden md:inline-flex" style={{ color: "var(--pass-text)", padding: "0 8px" }} data-testid="notif-enabled-badge">
                🔔 {T.notifEnabled}
              </span>
            )}
            <BudgetWidget budget={budget} onOpen={() => setBudgetModalOpen(true)} />
            <button className="btn btn-secondary" onClick={onReset} data-testid="new-upload-button">
              <RotateCcw size={14} /> {T.newUpload}
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-6 py-8">
        {/* Stats grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-testid="stats-grid">
          <Stat label={T.totalProducts} value={counts.all} tone="neutral" testid="stat-total" />
          <Stat label={T.compliant} value={counts.pass} tone="pass" testid="stat-pass" />
          <Stat label={T.warnings} value={counts.warning} tone="warning" testid="stat-warning" />
          <Stat label={T.nonCompliant} value={counts.fail} tone="fail" testid="stat-fail" />
        </div>

        {/* Before/After */}
        {statsAfter && (
          <div className="mt-6 panel px-6 py-4 flex items-center gap-6 flex-wrap" data-testid="before-after-panel">
            <div className="label-overline">{T.beforeAfter}</div>
            <BeforeAfterPill label={T.compliant} before={statsBefore.pass} after={statsAfter.pass} tone="pass" />
            <BeforeAfterPill label={T.warnings} before={statsBefore.warning} after={statsAfter.warning} tone="warning" />
            <BeforeAfterPill label={T.nonCompliant} before={statsBefore.fail} after={statsAfter.fail} tone="fail" />
          </div>
        )}

        {/* Actions bar */}
        <div className="mt-6 flex items-center justify-between gap-4 flex-wrap">
          <div className="flex items-center gap-1 flex-wrap">
            <FilterTab label={`${T.filterAll} · ${counts.all}`} active={filter==="all"} onClick={() => setFilter("all")} testid="filter-all" />
            <FilterTab label={`${T.filterPass} · ${counts.pass}`} active={filter==="pass"} onClick={() => setFilter("pass")} testid="filter-pass" />
            <FilterTab label={`${T.filterWarn} · ${counts.warning}`} active={filter==="warning"} onClick={() => setFilter("warning")} testid="filter-warning" />
            <FilterTab label={`${T.filterFail} · ${counts.fail}`} active={filter==="fail"} onClick={() => setFilter("fail")} testid="filter-fail" />
            <FilterTab label={`${T.filterReformulated} · ${counts.reformulated}`} active={filter==="reformulated"} onClick={() => setFilter("reformulated")} testid="filter-reformulated" />
            <div style={{ width: 1, height: 18, background: "var(--border-default)", margin: "0 10px" }} />
            <QuickSelect onPick={applyQuickSelect} counts={counts} />
          </div>
          <div className="flex items-center gap-2 flex-wrap">
            <button
              className="btn btn-secondary"
              onClick={triggerReformulateSelected}
              disabled={progress.status === "running" || (selectedHandles.size === 0 && filtered.length === 0)}
              data-testid="reformulate-filtered-button"
              title={selectedHandles.size > 0 ? `${selectedHandles.size} seleccionados` : `${filtered.length} filtrados`}
            >
              <Sparkles size={14} />
              {T.reformulateSelected} {selectedHandles.size > 0 ? `${selectedHandles.size} ${T.reformulateSelection}` : `(${filtered.length})`}
            </button>
            <button
              className="btn btn-primary"
              onClick={triggerReformulateAll}
              disabled={progress.status === "running"}
              data-testid="reformulate-all-button"
            >
              <Sparkles size={14} /> {T.reformulateAll}
            </button>
            <button
              className="btn btn-secondary"
              onClick={() => { setTranslateEcoMode(false); setTranslateModalOpen(true); }}
              disabled={progress.status === "running" || products.length === 0}
              data-testid="translate-button"
              title={selectedHandles.size > 0 ? `${selectedHandles.size} seleccionados` : "Todos los productos"}
            >
              <Languages size={14} /> {T.translate}
              {selectedHandles.size > 0 && <span className="badge badge-neutral">{selectedHandles.size}</span>}
            </button>
            <button
              className="btn btn-ghost"
              onClick={() => { setTranslateEcoMode(true); setTranslateModalOpen(true); }}
              disabled={progress.status === "running" || products.length === 0}
              data-testid="translate-eco-button"
              title={T.translateEcoTitle}
              style={{ fontSize: 12, padding: "0 10px", color: "var(--brand-accent)" }}
            >
              ⚡ {T.translateEco}
            </button>
            <ExportDropdown
              onExportES={() => handleExport()}
              onExportLang={(lang) => handleExport(lang)}
              onExportAll={() => handleExport("_all")}
              onExportReport={handleExportReport}
              onExportFeed={() => setFeedModalOpen(true)}
              exporting={exporting}
              availableLanguages={availableLanguages}
              selectionCount={selectedHandles.size}
            />
          </div>
        </div>

        {/* Compliance toolbar */}
        <div className="mt-3 flex items-center gap-3 flex-wrap" style={{ paddingTop: 10, borderTop: "1px dashed var(--border-default)" }}>
          <label className="flex items-center gap-2" style={{ fontSize: 12, color: "var(--text-secondary)" }} title={T.conservativeModeHint}>
            <input
              type="checkbox"
              checked={conservativeMode}
              onChange={(e) => setConservativeMode(e.target.checked)}
              data-testid="conservative-mode-toggle"
            />
            🛡️ {T.conservativeMode}
          </label>
          <button
            className="btn btn-ghost"
            onClick={handleCleanSession}
            disabled={cleaning || progress.status === "running"}
            data-testid="clean-session-button"
            style={{ fontSize: 12 }}
            title={T.cleanSessionHint}
          >
            {cleaning ? <Loader2 size={14} className="animate-spin" /> : "🧹"} {T.cleanSession}
          </button>
          <button
            className="btn btn-ghost"
            onClick={handleComplianceCheck}
            data-testid="compliance-check-button"
            style={{ fontSize: 12 }}
          >
            📋 {T.complianceReport}
          </button>
          {complianceReport && (
            <span className="font-mono" style={{ fontSize: 12, color: complianceReport.total_with_violations > 0 ? "var(--fail-text)" : "var(--pass-text)" }} data-testid="compliance-summary">
              {complianceReport.total_with_violations === 0
                ? `✓ ${complianceReport.total_checked} productos sin incumplimientos`
                : `⚠ ${complianceReport.total_with_violations} / ${complianceReport.total_checked} productos con incumplimientos`}
            </span>
          )}
        </div>

        {/* Search */}
        <div className="mt-5 relative" style={{ maxWidth: 420 }}>
          <Search size={14} style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "var(--text-tertiary)" }} />
          <input
            type="text"
            placeholder={T.search}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            data-testid="search-input"
            style={{
              width: "100%",
              height: 36,
              padding: "0 14px 0 36px",
              border: "1px solid var(--border-default)",
              background: "var(--bg-surface)",
              fontFamily: "inherit",
              fontSize: 13,
              outline: "none",
              borderRadius: 2,
            }}
            onFocus={(e) => e.target.style.borderColor = "var(--text-primary)"}
            onBlur={(e) => e.target.style.borderColor = "var(--border-default)"}
          />
        </div>

        {/* Progress */}
        {progress.status === "running" && (
          <div className="mt-6 panel px-6 py-5" data-testid="progress-panel">
            <div className="flex items-center justify-between">
              <div>
                <div className="label-overline" style={{ color: "var(--proc-text)" }}>{T.processingLabel}</div>
                <div className="mt-1 font-mono" style={{ fontSize: 12, color: "var(--text-tertiary)" }}>
                  {progress.current_handle || "—"}
                </div>
              </div>
              <div className="font-serif-display" style={{ fontSize: 28 }}>
                {progress.processed} <span style={{ color: "var(--text-tertiary)" }}>/ {progress.total}</span>
              </div>
            </div>
            <div className="progress-track mt-4">
              <div className="progress-fill" style={{ width: `${pct}%` }} />
            </div>
          </div>
        )}

        {/* Selection toolbar */}
        {selectedHandles.size > 0 && (
          <div className="mt-4 panel px-5 py-3 flex items-center justify-between gap-4 flex-wrap" style={{ background: "#FFFBEA", borderColor: "#FCD34D" }} data-testid="selection-toolbar">
            <div className="flex items-center gap-3">
              <span className="badge badge-warn">{selectedHandles.size}</span>
              <span style={{ fontSize: 13, color: "var(--text-primary)" }}>{T.selected}</span>
            </div>
            <div className="flex items-center gap-2">
              <button
                className="btn btn-ghost"
                onClick={() => setSelectedHandles(new Set(filtered.map(p => p.handle)))}
                data-testid="select-all-filtered"
              >
                {T.selectAll} ({filtered.length})
              </button>
              <button
                className="btn btn-ghost"
                onClick={() => setSelectedHandles(new Set())}
                data-testid="clear-selection"
                style={{ color: "var(--fail-text)" }}
              >
                <X size={12} /> {T.clearSelection}
              </button>
            </div>
          </div>
        )}

        {/* Products table */}
        <div className="mt-6 panel" data-testid="products-table">
          <div className="table-header">
            <div>
              <input
                type="checkbox"
                checked={filtered.length > 0 && filtered.every(p => selectedHandles.has(p.handle))}
                onChange={(e) => {
                  const next = new Set(selectedHandles);
                  if (e.target.checked) filtered.forEach(p => next.add(p.handle));
                  else filtered.forEach(p => next.delete(p.handle));
                  setSelectedHandles(next);
                }}
                data-testid="select-all-checkbox"
                style={{ accentColor: "#0A0A0A", cursor: "pointer" }}
              />
            </div>
            <div className="label-overline">{T.colImg}</div>
            <div className="label-overline">{T.colProduct}</div>
            <div className="label-overline">{T.colBrand}</div>
            <div className="label-overline text-right">{T.colPrice}</div>
            <div className="label-overline">{T.colVariants}</div>
            <div className="label-overline">{T.colStatus}</div>
            <div className="label-overline text-right">{T.colActions}</div>
          </div>
          {filtered.length === 0 ? (
            <div className="py-16 text-center" style={{ color: "var(--text-tertiary)" }}>{T.noProducts}</div>
          ) : (
            filtered.map((p) => (
              <div
                key={p.handle}
                className={`table-row cursor-pointer ${selectedHandles.has(p.handle) ? "selected" : ""}`}
                onClick={() => setSelectedHandle(p.handle)}
                data-testid={`product-row-${p.handle}`}
              >
                <div onClick={(e) => e.stopPropagation()}>
                  <input
                    type="checkbox"
                    checked={selectedHandles.has(p.handle)}
                    onChange={(e) => {
                      const next = new Set(selectedHandles);
                      if (e.target.checked) next.add(p.handle); else next.delete(p.handle);
                      setSelectedHandles(next);
                    }}
                    data-testid={`select-${p.handle}`}
                    style={{ accentColor: "#0A0A0A", cursor: "pointer" }}
                  />
                </div>
                <div>
                  {p.image ? (
                    <img src={p.image} alt="" style={{ width: 48, height: 48, objectFit: "cover", border: "1px solid var(--border-default)" }} />
                  ) : (
                    <div style={{ width: 48, height: 48, border: "1px dashed var(--border-default)", display: "flex", alignItems: "center", justifyContent: "center", color: "var(--text-tertiary)" }}>
                      <Watch size={16} strokeWidth={1.2} />
                    </div>
                  )}
                </div>
                <div className="min-w-0">
                  <div className="truncate-2" style={{ fontSize: 13.5, lineHeight: 1.4 }}>{p.title || "—"}</div>
                  <div className="mt-1 font-mono" style={{ fontSize: 11, color: "var(--text-tertiary)" }}>{p.handle}</div>
                </div>
                <div className="truncate" style={{ fontSize: 13, color: "var(--text-secondary)" }}>{p.vendor || "—"}</div>
                <div className="text-right font-mono" style={{ fontSize: 13 }}>{p.price ? `${p.price} €` : "—"}</div>
                <div className="font-mono" style={{ fontSize: 12, color: "var(--text-tertiary)" }}>
                  {p.variant_count} {T.variants}
                </div>
                <div className="flex items-center gap-2 flex-wrap">
                  <StatusBadge status={p.status_after || p.status} />
                  {p.reformulated && !p.reformulated.error && (
                    <span className="badge badge-proc"><Sparkles size={10} /> IA</span>
                  )}
                  {p.reformulated && p.reformulated.gtin && (
                    <span className="badge badge-pass" title={p.reformulated.gtin}>EAN</span>
                  )}
                </div>
                <div className="text-right">
                  <button
                    className="btn btn-ghost"
                    onClick={(e) => { e.stopPropagation(); setSelectedHandle(p.handle); }}
                    data-testid={`view-product-${p.handle}`}
                  >
                    {T.viewDetails} <ArrowRight size={12} />
                  </button>
                </div>
              </div>
            ))
          )}
        </div>

        <footer className="mt-10 py-6 flex items-center justify-between label-overline" style={{ color: "var(--text-tertiary)", borderTop: "1px solid var(--border-default)" }}>
          <span>{T.poweredBy}</span>
          <span>{T.footer}</span>
        </footer>
      </main>

      {selectedHandle && (
        <ProductDetail
          sessionId={session.session_id}
          handle={selectedHandle}
          onClose={() => setSelectedHandle(null)}
          onUpdated={refreshSession}
        />
      )}

      {translateModalOpen && (
        <TranslateModal
          reformulatedCount={counts.reformulated}
          totalCount={products.length}
          selectionCount={selectedHandles.size}
          defaultIncludeRaw={translateEcoMode}
          onClose={() => setTranslateModalOpen(false)}
          onConfirm={(langs, includeRaw) => { triggerTranslation(langs, null, includeRaw); setTranslateModalOpen(false); }}
        />
      )}

      {feedModalOpen && (
        <FeedModal
          sessionId={session.session_id}
          availableLanguages={availableLanguages}
          onClose={() => setFeedModalOpen(false)}
          onConfirm={handleFeedDownload}
        />
      )}

      {budgetModalOpen && (
        <BudgetModal
          budget={budget}
          onClose={() => setBudgetModalOpen(false)}
          onSaved={async () => { await refreshBudget(); }}
        />
      )}

      {complianceReport && (
        <ComplianceReportModal
          report={complianceReport}
          onClose={() => setComplianceReport(null)}
        />
      )}
    </div>
  );
}

const LANG_META = {
  fr: { flag: "🇫🇷", name: "Français" },
  en: { flag: "🇬🇧", name: "English" },
  pt: { flag: "🇵🇹", name: "Português" },
  de: { flag: "🇩🇪", name: "Deutsch" },
  it: { flag: "🇮🇹", name: "Italiano" },
};

function ExportDropdown({ onExportES, onExportLang, onExportAll, onExportReport, onExportFeed, exporting, availableLanguages, selectionCount = 0 }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const selSuffix = selectionCount > 0 ? ` · ${selectionCount}` : "";

  const item = (label, onClick, icon = null, testid = null, key = null) => (
    <button
      key={key}
      className="w-full text-left px-4 py-2.5 flex items-center gap-2"
      style={{ fontSize: 13, borderBottom: "1px solid var(--border-default)", background: "transparent" }}
      onMouseEnter={(e) => e.currentTarget.style.background = "var(--bg-surface-hover)"}
      onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
      onClick={() => { onClick(); setOpen(false); }}
      data-testid={testid}
    >
      {icon}
      <span>{label}</span>
    </button>
  );

  return (
    <div ref={ref} className="relative">
      <button
        className="btn btn-secondary"
        onClick={() => setOpen(v => !v)}
        disabled={exporting}
        data-testid="export-dropdown-button"
      >
        {exporting ? <span className="spinner" /> : <Download size={14} />} {T.exportDropdown}
        {selectionCount > 0 && <span className="badge badge-neutral">{selectionCount}</span>}
        <ChevronDown size={12} style={{ transition: "transform 0.15s", transform: open ? "rotate(180deg)" : "none" }} />
      </button>
      {open && (
        <div
          className="absolute right-0 mt-2 panel"
          style={{ zIndex: 20, minWidth: 300, padding: 0 }}
          data-testid="export-dropdown-menu"
        >
          {item(`${T.exportES}${selSuffix}`, onExportES, <Package size={14} />, "export-es-option", "es")}
          {availableLanguages.map(lang => item(
            `${T.exportLang} ${LANG_META[lang]?.flag || ""} ${LANG_META[lang]?.name || lang.toUpperCase()}${selSuffix}`,
            () => onExportLang(lang),
            <Package size={14} />,
            `export-${lang}-option`,
            lang
          ))}
          {availableLanguages.length > 0 && item(`${T.exportAll}${selSuffix}`, onExportAll, <Package size={14} />, "export-all-option", "all")}
          {item(T.exportReport, onExportReport, <FileSpreadsheet size={14} />, "export-report-option", "report")}
          {item(T.exportFeed, onExportFeed, <FileText size={14} />, "export-feed-option", "feed")}
        </div>
      )}
    </div>
  );
}

function FeedModal({ sessionId, availableLanguages, onClose, onConfirm }) {
  const [shopUrl, setShopUrl] = useState("https://");
  const [lang, setLang] = useState("es");
  const [currency, setCurrency] = useState("EUR");
  const [error, setError] = useState("");
  const [publicFeeds, setPublicFeeds] = useState([]);
  const [creatingPublic, setCreatingPublic] = useState(false);
  const [copiedToken, setCopiedToken] = useState(null);

  const allLangs = ["es", ...availableLanguages];

  const loadPublic = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/session/${sessionId}/public-feeds`);
      setPublicFeeds(r.data || []);
    } catch {}
  }, [sessionId]);

  useEffect(() => { loadPublic(); }, [loadPublic]);

  const validate = () => {
    if (!shopUrl.startsWith("http://") && !shopUrl.startsWith("https://")) {
      setError("La URL debe comenzar por http:// o https://"); return false;
    }
    if (shopUrl.length < 12) { setError("La URL parece demasiado corta."); return false; }
    setError(""); return true;
  };

  const submit = () => {
    if (!validate()) return;
    onConfirm({ shopUrl: shopUrl.replace(/\/$/, ""), lang, currency });
  };

  const createPublic = async () => {
    if (!validate()) return;
    setCreatingPublic(true);
    try {
      await axios.post(`${API}/session/${sessionId}/public-feed`, {
        shop_url: shopUrl.replace(/\/$/, ""),
        lang,
        currency,
      });
      await loadPublic();
    } catch (e) {
      setError(e?.response?.data?.detail || "Error al crear la URL pública");
    } finally {
      setCreatingPublic(false);
    }
  };

  const copyUrl = async (url, token) => {
    try {
      await navigator.clipboard.writeText(url);
      setCopiedToken(token);
      setTimeout(() => setCopiedToken(null), 2000);
    } catch {}
  };

  const deletePublic = async (token) => {
    try {
      await axios.delete(`${API}/public-feed/${token}`);
      await loadPublic();
    } catch {}
  };

  return (
    <div className="modal-overlay" onClick={onClose} style={{ alignItems: "center", justifyContent: "center" }}>
      <div
        onClick={(e) => e.stopPropagation()}
        className="panel"
        style={{ maxWidth: 680, width: "92%", padding: "28px 32px", maxHeight: "90vh", overflowY: "auto", animation: "fade-in 0.15s ease" }}
        data-testid="feed-modal"
      >
        <div className="flex items-start justify-between gap-4">
          <div>
            <div className="label-overline">Feed XML</div>
            <div className="font-serif-display mt-2" style={{ fontSize: 26, fontWeight: 500, lineHeight: 1.1 }}>{T.feedModalTitle}</div>
            <div className="mt-2" style={{ fontSize: 13, color: "var(--text-secondary)" }}>{T.feedModalHint}</div>
          </div>
          <button className="btn btn-ghost" onClick={onClose} data-testid="close-feed-modal"><X size={16} /></button>
        </div>

        <div className="mt-6 space-y-4">
          <div>
            <div className="label-overline mb-2">{T.feedShopUrlLabel}</div>
            <input
              type="text"
              value={shopUrl}
              onChange={(e) => setShopUrl(e.target.value)}
              placeholder={T.feedShopUrlPlaceholder}
              data-testid="feed-shop-url-input"
              style={{
                width: "100%", height: 38, padding: "0 14px",
                border: "1px solid var(--border-strong)",
                background: "var(--bg-surface)",
                fontFamily: "'IBM Plex Mono', monospace", fontSize: 13, outline: "none", borderRadius: 2,
              }}
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <div className="label-overline mb-2">{T.feedLanguageLabel}</div>
              <select
                value={lang}
                onChange={(e) => {
                  setLang(e.target.value);
                  if (e.target.value === "en") setCurrency("GBP"); else setCurrency("EUR");
                }}
                data-testid="feed-lang-select"
                style={{
                  width: "100%", height: 38, padding: "0 12px",
                  border: "1px solid var(--border-strong)", background: "var(--bg-surface)",
                  fontFamily: "inherit", fontSize: 13, outline: "none", borderRadius: 2,
                }}
              >
                {allLangs.map(l => (
                  <option key={l} value={l}>
                    {l === "es" ? "🇪🇸 Español" : `${LANG_META[l]?.flag || ""} ${LANG_META[l]?.name || l.toUpperCase()}`}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <div className="label-overline mb-2">{T.feedCurrencyLabel}</div>
              <select
                value={currency}
                onChange={(e) => setCurrency(e.target.value)}
                data-testid="feed-currency-select"
                style={{
                  width: "100%", height: 38, padding: "0 12px",
                  border: "1px solid var(--border-strong)", background: "var(--bg-surface)",
                  fontFamily: "inherit", fontSize: 13, outline: "none", borderRadius: 2,
                }}
              >
                <option value="EUR">EUR — Euro</option>
                <option value="GBP">GBP — British Pound</option>
                <option value="USD">USD — US Dollar</option>
                <option value="CHF">CHF — Swiss Franc</option>
              </select>
            </div>
          </div>

          {error && <div style={{ fontSize: 12, color: "var(--fail-text)" }} data-testid="feed-error">{error}</div>}
        </div>

        <div className="mt-6 flex gap-2 justify-end flex-wrap">
          <button className="btn btn-secondary" onClick={onClose} data-testid="cancel-feed">Cancelar</button>
          <button className="btn btn-secondary" onClick={createPublic} disabled={creatingPublic} data-testid="create-public-feed">
            {creatingPublic ? <span className="spinner" /> : <Sparkles size={14} />} {T.feedPublic}
          </button>
          <button className="btn btn-primary" onClick={submit} data-testid="confirm-feed"><Download size={14} /> {T.feedGenerate}</button>
        </div>

        {publicFeeds.length > 0 && (
          <div className="mt-8" data-testid="public-feeds-list">
            <div className="label-overline">{T.feedExistingPublic}</div>
            <div className="mt-3 panel" style={{ padding: 0 }}>
              {publicFeeds.map(f => (
                <div key={f.token} className="flex items-center gap-3 px-4 py-3" style={{ borderBottom: "1px solid var(--border-default)" }}>
                  <span className="badge badge-proc" style={{ minWidth: 50, justifyContent: "center" }}>
                    {f.lang === "es" ? "🇪🇸" : LANG_META[f.lang]?.flag} {f.lang.toUpperCase()}
                  </span>
                  <div className="flex-1 min-w-0">
                    <div className="font-mono truncate" style={{ fontSize: 11, color: "var(--text-secondary)" }}>{f.url}</div>
                    <div className="label-overline mt-1" style={{ color: "var(--text-tertiary)" }}>
                      {f.currency} · {f.fetch_count || 0} {T.feedFetches} · {f.shop_url}
                    </div>
                  </div>
                  <button
                    className="btn btn-ghost"
                    onClick={() => copyUrl(f.url, f.token)}
                    data-testid={`copy-feed-${f.token}`}
                    style={{ color: copiedToken === f.token ? "var(--pass-text)" : undefined }}
                  >
                    {copiedToken === f.token ? <><Check size={12} /> {T.feedCopied}</> : <>📋 {T.feedCopyUrl}</>}
                  </button>
                  <button
                    className="btn btn-ghost"
                    onClick={() => deletePublic(f.token)}
                    data-testid={`delete-feed-${f.token}`}
                    style={{ color: "var(--fail-text)" }}
                  >
                    <X size={12} /> {T.feedDelete}
                  </button>
                </div>
              ))}
            </div>
            <div className="mt-3 label-overline" style={{ color: "var(--text-tertiary)" }}>
              {T.feedPublicHint}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function TranslateModal({ reformulatedCount, totalCount = 0, selectionCount = 0, defaultIncludeRaw = false, onClose, onConfirm }) {
  const [selected, setSelected] = useState({ fr: true, en: true, pt: false, de: false, it: false });
  // Auto-enable "include non-reformulated" when no product has been reformulated yet (smart default for eco mode)
  const [includeRaw, setIncludeRaw] = useState(defaultIncludeRaw || reformulatedCount === 0);
  const toggle = (k) => setSelected(s => ({ ...s, [k]: !s[k] }));
  const chosen = Object.keys(selected).filter(k => selected[k]);
  const effectiveCount = selectionCount > 0
    ? selectionCount
    : (includeRaw ? totalCount : reformulatedCount);
  const scopeLabel = selectionCount > 0
    ? `${selectionCount} productos seleccionados`
    : includeRaw
      ? `${totalCount} productos (todos, con o sin reformular)`
      : `${reformulatedCount} productos reformulados`;

  return (
    <div className="modal-overlay" onClick={onClose} style={{ alignItems: "center", justifyContent: "center" }}>
      <div
        onClick={(e) => e.stopPropagation()}
        className="panel"
        style={{ maxWidth: 560, width: "90%", padding: "28px 32px", animation: "fade-in 0.15s ease" }}
        data-testid="translate-modal"
      >
        <div className="flex items-start justify-between gap-4">
          <div>
            <div className="label-overline">{T.translate}</div>
            <div className="font-serif-display mt-2" style={{ fontSize: 26, fontWeight: 500, lineHeight: 1.1 }}>{T.translateTitle}</div>
            <div className="mt-2" style={{ fontSize: 13, color: "var(--text-secondary)" }}>{T.translateHint}</div>
          </div>
          <button className="btn btn-ghost" onClick={onClose} data-testid="close-translate-modal">
            <X size={16} />
          </button>
        </div>

        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-2">
          {Object.entries(LANG_META).map(([code, meta]) => (
            <label
              key={code}
              className="flex items-center gap-3 px-3 py-3"
              style={{
                border: `1px solid ${selected[code] ? "var(--text-primary)" : "var(--border-default)"}`,
                background: selected[code] ? "#FAFAF9" : "var(--bg-surface)",
                cursor: "pointer",
                borderRadius: 2,
                transition: "border-color 0.15s",
              }}
              data-testid={`lang-option-${code}`}
            >
              <input
                type="checkbox"
                checked={selected[code]}
                onChange={() => toggle(code)}
                style={{ accentColor: "#0A0A0A" }}
              />
              <span style={{ fontSize: 18 }}>{meta.flag}</span>
              <span style={{ fontSize: 14 }}>{meta.name}</span>
              <span className="label-overline ml-auto">{code}</span>
            </label>
          ))}
        </div>

        {/* Include non-reformulated toggle */}
        {selectionCount === 0 && (
          <label
            className="mt-5 flex items-start gap-3 px-4 py-3"
            style={{
              border: `1px solid ${includeRaw ? "var(--text-primary)" : "var(--border-default)"}`,
              background: includeRaw ? "#FAFAF9" : "var(--bg-surface)",
              cursor: "pointer",
              borderRadius: 2,
              transition: "border-color 0.15s",
            }}
            data-testid="include-raw-toggle"
          >
            <input
              type="checkbox"
              checked={includeRaw}
              onChange={(e) => setIncludeRaw(e.target.checked)}
              style={{ accentColor: "#0A0A0A", marginTop: 3 }}
            />
            <div>
              <div style={{ fontSize: 13, fontWeight: 500 }}>{T.translateIncludeRaw}</div>
              <div className="label-overline mt-1" style={{ color: "var(--text-tertiary)" }}>
                {includeRaw ? `Traducirá ${totalCount} productos` : `Solo ${reformulatedCount} productos reformulados`}
              </div>
            </div>
          </label>
        )}

        <div className="mt-5 label-overline" style={{ color: "var(--text-tertiary)" }}>
          {scopeLabel} · {chosen.length} idiomas seleccionados · ≈ {effectiveCount * chosen.length} llamadas IA
        </div>

        <div className="mt-6 flex gap-2 justify-end">
          <button className="btn btn-secondary" onClick={onClose} data-testid="cancel-translate">Cancelar</button>
          <button
            className="btn btn-primary"
            onClick={() => onConfirm(chosen, includeRaw)}
            disabled={chosen.length === 0 || effectiveCount === 0}
            data-testid="confirm-translate"
          >
            <Languages size={14} /> {T.translateStart}
          </button>
        </div>
      </div>
    </div>
  );
}

function BeforeAfterPill({ label, before, after, tone }) {
  const delta = after - before;
  const arrow = delta > 0 ? "+" : delta < 0 ? "−" : "±";
  return (
    <div className="flex items-center gap-2">
      <span className={`badge badge-${tone === "pass" ? "pass" : tone === "warning" ? "warn" : "fail"}`}>{label}</span>
      <span className="font-mono" style={{ fontSize: 12 }}>
        {before} <ArrowRight size={10} style={{ display: "inline", margin: "0 4px" }} /> {after}
      </span>
      {delta !== 0 && (
        <span className="font-mono" style={{ fontSize: 11, color: delta > 0 && tone==="pass" ? "var(--pass-text)" : delta < 0 && tone !== "pass" ? "var(--pass-text)" : "var(--text-tertiary)" }}>
          ({arrow}{Math.abs(delta)})
        </span>
      )}
    </div>
  );
}

function QuickSelect({ onPick, counts }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const item = (label, count, kind, icon, tone = "neutral") => (
    <button
      key={kind}
      className="w-full text-left px-4 py-2.5 flex items-center gap-2"
      style={{ fontSize: 13, borderBottom: "1px solid var(--border-default)", background: "transparent" }}
      onMouseEnter={(e) => e.currentTarget.style.background = "var(--bg-surface-hover)"}
      onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
      onClick={() => { onPick(kind); setOpen(false); }}
      data-testid={`quick-select-${kind}`}
    >
      {icon}
      <span style={{ flex: 1 }}>{label}</span>
      {typeof count === "number" && (
        <span className={`badge badge-${tone === "pass" ? "pass" : tone === "warn" ? "warn" : tone === "fail" ? "fail" : "neutral"}`}>
          {count}
        </span>
      )}
    </button>
  );

  return (
    <div ref={ref} className="relative">
      <button
        className="pill-tab"
        onClick={() => setOpen(v => !v)}
        data-testid="quick-select-button"
        style={{ display: "inline-flex", alignItems: "center", gap: 6 }}
      >
        <Sparkles size={11} /> {T.quickSelect}
        <ChevronDown size={11} style={{ transition: "transform 0.15s", transform: open ? "rotate(180deg)" : "none" }} />
      </button>
      {open && (
        <div className="absolute left-0 mt-2 panel" style={{ zIndex: 20, minWidth: 280, padding: 0 }} data-testid="quick-select-menu">
          {item(T.quickFail, counts.fail, "fail", <XCircle size={13} style={{ color: "var(--fail-text)" }} />, "fail")}
          {item(T.quickWarn, counts.warning, "warn", <AlertTriangle size={13} style={{ color: "var(--warn-text)" }} />, "warn")}
          {item(T.quickPass, counts.pass, "pass", <CheckCircle2 size={13} style={{ color: "var(--pass-text)" }} />, "pass")}
          {item(T.quickNotReformulated, counts.all - counts.reformulated, "not_reformulated", <Sparkles size={13} style={{ color: "var(--text-tertiary)" }} />, "neutral")}
          {item(T.quickNotTranslated, null, "not_translated", <Languages size={13} style={{ color: "var(--text-tertiary)" }} />, "neutral")}
          {item(T.quickInvert, null, "invert", <RotateCcw size={13} />, "neutral")}
        </div>
      )}
    </div>
  );
}

function FilterTab({ label, active, onClick, testid }) {
  return (
    <button className={`pill-tab ${active ? "active" : ""}`} onClick={onClick} data-testid={testid}>
      {label}
    </button>
  );
}

// ---------------- Budget widget & modal ----------------
function fmtEUR(n) {
  const v = Number(n || 0);
  return v.toLocaleString("es-ES", { style: "currency", currency: "EUR", maximumFractionDigits: 2 });
}

function BudgetWidget({ budget, onOpen }) {
  if (!budget) {
    return (
      <button className="btn btn-ghost" onClick={onOpen} data-testid="budget-widget-loading" title={T.budgetSettings}>
        <Wallet size={14} /> {T.budgetSettings}
      </button>
    );
  }
  const sessionEUR = budget.session?.cost_eur || 0;
  const monthEUR = budget.month?.cost_eur || 0;
  const sessionCap = budget.settings?.session_eur || 0;
  const monthCap = budget.settings?.monthly_eur || 0;
  const enabled = budget.settings?.enabled;
  const sessionPct = sessionCap > 0 ? Math.min(100, (sessionEUR / sessionCap) * 100) : 0;
  const monthPct = monthCap > 0 ? Math.min(100, (monthEUR / monthCap) * 100) : 0;
  const tone = (sessionPct >= 90 || monthPct >= 90) ? "var(--fail-text)" : (sessionPct >= 70 || monthPct >= 70) ? "var(--warning-text, #b45309)" : "var(--text-secondary)";
  return (
    <button
      className="btn btn-ghost"
      onClick={onOpen}
      data-testid="budget-widget"
      title={T.budgetTitle}
      style={{ display: "inline-flex", flexDirection: "column", alignItems: "flex-start", padding: "6px 12px", lineHeight: 1.1 }}
    >
      <span className="label-overline" style={{ color: tone, display: "inline-flex", alignItems: "center", gap: 6 }}>
        <Wallet size={12} /> {T.budgetSettings}
      </span>
      <span className="font-mono" style={{ fontSize: 11, color: "var(--text-secondary)" }}>
        {T.budgetThisSession}: <strong style={{ color: tone }}>{fmtEUR(sessionEUR)}</strong>{enabled && sessionCap > 0 ? ` / ${fmtEUR(sessionCap)}` : ""}
      </span>
      <span className="font-mono" style={{ fontSize: 11, color: "var(--text-tertiary)" }}>
        {T.budgetThisMonth}: {fmtEUR(monthEUR)}{enabled && monthCap > 0 ? ` / ${fmtEUR(monthCap)}` : ""}
      </span>
    </button>
  );
}

function BudgetModal({ budget, onClose, onSaved }) {
  const [monthlyEur, setMonthlyEur] = useState(budget?.settings?.monthly_eur ?? 100);
  const [sessionEur, setSessionEur] = useState(budget?.settings?.session_eur ?? 10);
  const [enabled, setEnabled] = useState(budget?.settings?.enabled ?? true);
  const [saving, setSaving] = useState(false);
  const [savedFlag, setSavedFlag] = useState(false);

  const session = budget?.session || { cost_eur: 0, input_tokens: 0, output_tokens: 0, calls: 0 };
  const month = budget?.month || { cost_eur: 0, input_tokens: 0, output_tokens: 0, calls: 0 };
  const allTime = budget?.all_time || { cost_eur: 0, input_tokens: 0, output_tokens: 0, calls: 0 };
  const byMode = budget?.by_mode || [];

  const modeLabel = (m) => ({
    reformulate: T.modeReformulate,
    translate: T.modeTranslate,
    gtin_validation: T.modeGtin,
  })[m] || m;

  const save = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/budget`, {
        monthly_eur: Number(monthlyEur),
        session_eur: Number(sessionEur),
        enabled: !!enabled,
      });
      setSavedFlag(true);
      if (onSaved) await onSaved();
      setTimeout(() => setSavedFlag(false), 2000);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose} data-testid="budget-modal">
      <div className="modal-panel" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 720, width: "92vw" }}>
        <div className="flex items-center justify-between px-8 py-5" style={{ borderBottom: "1px solid var(--border-default)", background: "var(--bg-surface)" }}>
          <div>
            <div className="label-overline" style={{ color: "var(--text-tertiary)" }}>Google Merchant · IA</div>
            <div className="font-serif-display" style={{ fontSize: 22, fontWeight: 500 }}>{T.budgetTitle}</div>
          </div>
          <button className="btn btn-ghost" onClick={onClose} data-testid="budget-modal-close" aria-label="Cerrar"><X size={16} /></button>
        </div>

        <div className="px-8 py-6" style={{ display: "grid", gap: 18 }}>
          <p style={{ fontSize: 13, color: "var(--text-secondary)", margin: 0 }}>{T.budgetHint}</p>

          {/* Consumption summary */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            <ConsumptionCard label={T.budgetThisSession} stats={session} testid="budget-card-session" />
            <ConsumptionCard label={T.budgetThisMonth} stats={month} testid="budget-card-month" />
            <ConsumptionCard label={T.budgetAllTime} stats={allTime} testid="budget-card-all" />
          </div>

          {byMode.length > 0 && (
            <div>
              <div className="label-overline mb-2">{T.budgetByMode}</div>
              <div style={{ display: "grid", gap: 6 }}>
                {byMode.map(m => (
                  <div key={m.mode} className="flex items-center justify-between" style={{ borderBottom: "1px solid var(--border-subtle, #eee)", padding: "6px 0" }}>
                    <span className="font-mono" style={{ fontSize: 13 }}>{modeLabel(m.mode)}</span>
                    <span className="font-mono" style={{ fontSize: 12, color: "var(--text-secondary)" }}>
                      {m.calls} {T.budgetCalls} · {(m.input_tokens + m.output_tokens).toLocaleString("es-ES")} {T.budgetTokens} · <strong>{fmtEUR(m.cost_eur)}</strong>
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Settings */}
          <div style={{ borderTop: "1px solid var(--border-default)", paddingTop: 16 }}>
            <label className="flex items-center gap-2 mb-3" style={{ fontSize: 13 }}>
              <input
                type="checkbox"
                checked={enabled}
                onChange={(e) => setEnabled(e.target.checked)}
                data-testid="budget-enabled-toggle"
              />
              <Settings size={14} /> {T.budgetEnabled}
            </label>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <div>
                <div className="label-overline mb-2">{T.budgetMonthlyLabel}</div>
                <input
                  type="number" step="1" min="0"
                  value={monthlyEur}
                  onChange={(e) => setMonthlyEur(e.target.value)}
                  data-testid="budget-monthly-input"
                  style={{ width: "100%", height: 38, padding: "0 12px", border: "1px solid var(--border-strong)", background: "var(--bg-surface)", fontFamily: "inherit", fontSize: 13, outline: "none", borderRadius: 2 }}
                />
              </div>
              <div>
                <div className="label-overline mb-2">{T.budgetSessionLabel}</div>
                <input
                  type="number" step="0.5" min="0"
                  value={sessionEur}
                  onChange={(e) => setSessionEur(e.target.value)}
                  data-testid="budget-session-input"
                  style={{ width: "100%", height: 38, padding: "0 12px", border: "1px solid var(--border-strong)", background: "var(--bg-surface)", fontFamily: "inherit", fontSize: 13, outline: "none", borderRadius: 2 }}
                />
              </div>
            </div>
          </div>

          <div className="flex gap-2 justify-end flex-wrap">
            <button className="btn btn-secondary" onClick={onClose} data-testid="budget-cancel">{T.close}</button>
            <button className="btn btn-primary" onClick={save} disabled={saving} data-testid="budget-save">
              {saving ? <Loader2 size={14} className="animate-spin" /> : <Check size={14} />} {savedFlag ? T.budgetSaved : T.budgetSave}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function ConsumptionCard({ label, stats, testid }) {
  return (
    <div className="panel px-4 py-3" data-testid={testid}>
      <div className="label-overline">{label}</div>
      <div className="font-serif-display mt-1" style={{ fontSize: 22, lineHeight: 1.1 }}>{fmtEUR(stats.cost_eur)}</div>
      <div className="font-mono mt-1" style={{ fontSize: 11, color: "var(--text-tertiary)" }}>
        {stats.calls || 0} {T.budgetCalls} · {((stats.input_tokens || 0) + (stats.output_tokens || 0)).toLocaleString("es-ES")} {T.budgetTokens}
      </div>
    </div>
  );
}

function ComplianceReportModal({ report, onClose }) {
  const total = report.total_checked || 0;
  const violations = report.total_with_violations || 0;
  const byCat = report.by_category || {};
  const items = report.products_with_violations || [];
  return (
    <div className="modal-overlay" onClick={onClose} data-testid="compliance-modal">
      <div className="modal-panel" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 820, width: "92vw" }}>
        <div className="flex items-center justify-between px-8 py-5" style={{ borderBottom: "1px solid var(--border-default)", background: "var(--bg-surface)" }}>
          <div>
            <div className="label-overline" style={{ color: "var(--text-tertiary)" }}>Google Merchant</div>
            <div className="font-serif-display" style={{ fontSize: 22, fontWeight: 500 }}>{T.complianceModalTitle}</div>
            <div className="label-overline mt-1" style={{ color: violations > 0 ? "var(--fail-text)" : "var(--pass-text)" }}>
              {violations === 0 ? `✓ ${total} productos OK` : `⚠ ${violations} / ${total} productos con incumplimientos`}
            </div>
          </div>
          <button className="btn btn-ghost" onClick={onClose} data-testid="compliance-modal-close"><X size={16} /></button>
        </div>

        <div className="px-8 py-6" style={{ display: "grid", gap: 18, maxHeight: "70vh", overflowY: "auto" }}>
          {violations === 0 && (
            <div className="panel px-6 py-8" style={{ textAlign: "center", color: "var(--pass-text)" }} data-testid="compliance-none">
              ✓ {T.complianceNone}
            </div>
          )}
          {Object.keys(byCat).length > 0 && (
            <div>
              <div className="label-overline mb-2">{T.complianceCategoryLabel}</div>
              <div style={{ display: "grid", gap: 6 }}>
                {Object.entries(byCat).sort((a, b) => b[1] - a[1]).map(([cat, n]) => (
                  <div key={cat} className="flex items-center justify-between" style={{ borderBottom: "1px solid var(--border-default)", padding: "6px 0", fontSize: 13 }}>
                    <span className="font-mono">{cat}</span>
                    <span className="font-mono" style={{ color: "var(--text-secondary)" }}>{n} {T.complianceCountLabel.toLowerCase()}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
          {items.length > 0 && (
            <div>
              <div className="label-overline mb-2">{T.complianceProductsLabel}</div>
              <div style={{ display: "grid", gap: 10 }}>
                {items.map(item => (
                  <div key={item.handle} className="panel px-4 py-3" data-testid={`compliance-product-${item.handle}`}>
                    <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 6 }}>{item.title || item.handle}</div>
                    <div className="font-mono" style={{ fontSize: 11, color: "var(--text-tertiary)", marginBottom: 6 }}>{item.handle}</div>
                    {Object.entries(item.violations).map(([field, vlist]) => (
                      <div key={field} style={{ marginBottom: 4 }}>
                        <span className="label-overline" style={{ marginRight: 8 }}>{field}</span>
                        {vlist.map((v, i) => (
                          <span key={i} className="badge" style={{ marginRight: 4, fontSize: 10, color: v.severity === "fail" ? "var(--fail-text)" : "var(--text-secondary)" }}>
                            [{v.category}] {v.match}
                          </span>
                        ))}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="px-8 py-4 flex justify-end" style={{ borderTop: "1px solid var(--border-default)" }}>
          <button className="btn btn-secondary" onClick={onClose} data-testid="compliance-close">{T.complianceClose}</button>
        </div>
      </div>
    </div>
  );
}

// ---------------- App ----------------
export default function App() {
  const [session, setSession] = useState(null);

  return session ? (
    <Dashboard session={session} onReset={() => setSession(null)} />
  ) : (
    <UploadView onUploaded={setSession} />
  );
}
